import {SysConfig, PageConfig, CommonCode} from "@/env/SysConfig.js";
import http from "@/service/util/http.js";
import GridConfig from "@/views/Common/Modal/GridConfig.vue";

export default {
  data() {
    return {
      popMode: false,
      sysConfig: SysConfig,
      pageConfig: PageConfig,
      commonCode: CommonCode,
      _http: http,
      gridConfig: [],
      enterKeyDirectionGlobal: "row",
    };
  },
  created() {},
  mounted() {
    if (this.$attrs.sender) this.popMode = this.$attrs.sender.popMode;
    if (this.$refs.SearchPanel) this.$refs.SearchPanel.onSearch(); // ★★★ 20210127 임시코딩 - 추후 삭제할것!★★★
  },
  methods: {
    showModal(component, resultMethod, sender, size) {
      let _sender = sender || {};
      _sender["popMode"] = true;

      let _size = size || {};

      this.$modal.show(component, {sender: _sender}, size, {
        "before-close": resultMethod,
      });
    },

    onClickForSaveConfig(e, sender) {
      //-- console.log("onClickForSaveConfig");
      this.showModal(GridConfig, {}, this, {
        width: "20%",
        height: "100%",
        class: "fx_right",
      });
    },

    BaseItemGridToolbarPreparing(e) {
      let toolbarItems = e.toolbarOptions.items;
      var dataGrid_Temp = e.component;
      var that = this;
      toolbarItems.push({
        widget: "dxButton",
        options: {
          icon: "decreaseindent",
          onClick: this.insertItem,
          text: this.fm("삽입"),
        },
        location: "after",
      });

      toolbarItems.push({
        widget: "dxButton",
        options: {
          icon: "plus",
          text: this.fm("추가"),
          onClick: this.appendItem,
        },
        location: "after",
      });

      toolbarItems.push({
        widget: "dxButton",
        options: {
          icon: "minus",
          text: this.fm("삭제"),
          onClick: this.deleteItem,
        },
        location: "after",
      });

      toolbarItems.push({
        widget: "dxSelectBox",
        options: {
          width: 120,
          items: [
            {
              value: "column",
              text: this.fm("세로이동"),
            },
            {
              value: "row",
              text: this.fm("가로이동"),
            },
            {
              value: "none",
              text: this.fm("이동안함"),
            },
          ],
          displayExpr: "text",
          valueExpr: "value",
          value: this.enterKeyDirectionGlobal,
          _component: that,
          onValueChanged: function(data) {
            this.option()._component.enterKeyDirection = data.value;
            this.enterKeyDirectionGlobal = data.value;
            //dataGrid_Temp.keyboardNavigation.enterKeyDirection = data.value;

            //this.enterKeyDirection = data.value;
          },
        },
        location: "before",
      });
    },

    BaseListGridToolbarPreparing(e) {
      let toolbarItems = e.toolbarOptions.items;

      var dataGrid_Temp = e.component;
      var that = this;

      toolbarItems.unshift({
        text: this.fm("엑셀다운로드"),
        location: "after",
      });

      toolbarItems.splice(2, 0, {
        text: this.fm("컬럼설정"),
        location: "after",
      });
      //그리스 설정 조회
      // let id = this.$route.name + "_" + e.element.id;
      // var params = new URLSearchParams();
      // params.append("pageName", id);
      // //params.append("userId", this.sysConfig.userID);
      // http.get(`/gridConfigs`, params).then((res) => {
      //   let gridConfigData = res.data.content;
      //   that.gridConfig = gridConfigData;
      //   that["gridConfig_" + id] = gridConfigData;
      // });

      //컬럼설정 목록 추가 -------------------------------------------

      //임시 주석

      // toolbarItems.push(
      //   {
      //     html: "<div class='toolBarLabel'>컬럼설정<div>",
      //     location: "before",
      //   },
      //   {
      //     widget: "dxSelectBox",
      //     options: {
      //       width: 120,
      //       items: that.gridConfig,
      //       displayExpr: "gridName",

      //       value: "gridConfig",
      //       _component: dataGrid_Temp,
      //       onValueChanged: function(data) {
      //         let columns = JSON.parse(data.value.gridConfig);
      //         that.parent.columns = columns.columns;
      //         //this.option()._component.enterKeyDirection = data.value;
      //         //dataGrid_Temp.keyboardNavigation.enterKeyDirection = data.value;
      //         //this.enterKeyDirection = data.value;
      //       },
      //     },
      //     location: "before",
      //   }
      // );

      //컬럼 설정 관리 팝업 오픈-------------------------------------------
      //임시 주석
      // toolbarItems.push({
      //   widget: "dxButton",
      //   options: {
      //     icon: "preferences",
      //     onClick: this.onClickForSaveConfig,
      //     text: this.fm("컬럼설정관리"),
      //   },
      //   location: "before",
      // });

      // toolbarItems.push({
      //   widget: "dxButton",
      //   options: {
      //     icon: "fa fa-repeat",
      //     onClick: this.onClickForDeleteConfig,
      //     text: this.fm("설정삭제"),
      //   },
      //   location: "before",
      // });

      // toolbarItems.push({
      //   widget: "dxButton",
      //   options: {
      //     icon: "fa fa-file-excel-o",
      //     onClick: this.onClickForExcelExport,
      //     text: this.fm("Excel Export"),
      //   },
      //   location: "before",
      // });
    },

    BaseItemGridEditorPreparingAutoCalc(e) {
      var that = this;
      const defaultValueChangeHandler = e.editorOptions.onValueChanged;
      e.editorOptions.onValueChanged = function(value) {
        defaultValueChangeHandler.apply(this, arguments);

        if (e.parentType === "dataRow" && ["quantity", "price"].includes(e.dataField) && e.row.data.price) {
          let rowData = e.row.data;
          let focusedIndex = e.row.rowIndex;
          //값을 읽을때는 e.row.data 이용
          //값을 수정할떼는 cellValue
          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "total", rowData.quantity * rowData.price);
          //외화 금액 체크
          let selectRow = that.parent?.selectRow;
          if (selectRow?.exchangeRate) {
            that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "priceForeignCurrency", (rowData.price / selectRow.exchangeRate).toFixed(2));

            that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "totalForeignCurrency", rowData.quantity * rowData.priceForeignCurrency);
          }
        }
      };
    },

    BaseItemSearchKeyUp(value, that, defaultKeyUpHandler) {
      if (value.event.key == "ArrowUp" || value.event.key == "ArrowDown") {
        that.$refs.ItemSelectComponent?.KeyDown(value.event, null);
      } else if (value.event.ctrlKey && value.event.key == "Enter") {
        let itemSelectGrid = that.$refs.ItemSelectComponent.$refs.DataGrid_ItemCode;
        let seletedRowItemCode = that.$refs.ItemSelectComponent.dataSource.filter((item) => {
          return item.id === itemSelectGrid.focusedRowKey;
        });

        if (seletedRowItemCode?.length == 1) {
          let ItemRow = that.parent.selectRowItems.filter((e) => {
            return e.sequenceNumber === that.focusedRowKey;
          });

          let focusedIndex = that.$refs.DataGrid_Item.instance.getRowIndexByKey(that.$refs.DataGrid_Item.focusedRowKey);
          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "itemCode", seletedRowItemCode[0].itemCode);
          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "itemName", seletedRowItemCode[0].itemName);

          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "unit", seletedRowItemCode[0].unit);

          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "specification", seletedRowItemCode[0].specification);

          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "partNumber", seletedRowItemCode[0].partNumber);

          that.$refs.DataGrid_Item.instance.cellValue(focusedIndex, "maker", seletedRowItemCode[0].maker);

          that.$refs.DataGrid_Item.instance.saveEditData();
          that.$refs.DataGrid_Item.instance.focus(value.component);
          that.$refs.DataGrid_Item.instance.focus();
          that.display = false;
        }
      } else if (!value.event.ctrlKey && value.event.key != "Enter") {
        let component = value.component;
        if (value.event.currentTarget.value.length > 1) {
          that.SearchString = value.event.currentTarget.value;
          that.SearchKey = that.$refs.DataGrid_Item.instance.getVisibleColumns()[that.$refs.DataGrid_Item.focusedColumnIndex].dataField;
          that.display = true;
          var obj = this;
        }
      }
      if (defaultKeyUpHandler) defaultKeyUpHandler(value);
    },

    BaseGridSetRepositoryCommonCode(e, sGroupCd, that) {
      //keyDown 이벤트 죽이기
      e.editorOptions.onKeyDown = function(value) {
        if (value.event.key == "Enter") {
          value.event.preventDefault();
        }
      };

      //keyUp 이벤트 바인딩
      e.editorOptions.onKeyUp = function(value) {
        if (value.event.key == "Enter") {
          //Enter 누를때
          that.$refs.DataGrid_Item.instance.saveEditData(); //수정데이터 반영

          //다음 cell로 이동후 편집
          //이동모드 별 셀이동
          //if (that.$refs.DataGrid_Item.instance._controllers.keyboardNavigation.focusType == "cell")
          if (that.enterKeyDirection == "row") {
            that.$refs.DataGrid_Item.instance.editCell(
              that.$refs.DataGrid_Item.instance.getRowIndexByKey(that.$refs.DataGrid_Item.focusedRowKey),
              e.visibleIndex - 1
            );
          } else {
            that.$refs.DataGrid_Item.instance.editCell(
              that.$refs.DataGrid_Item.instance.getRowIndexByKey(that.$refs.DataGrid_Item.focusedRowKey) + 1,
              e.visibleIndex - 2
            );
          }
        }
      };
      let arrUnitCode = that.UserLib.fnGetCommonCodes("Unit");
      e.editorOptions.items = arrUnitCode;
      e.editorOptions.acceptCustomValue = true;
      e.editorOptions.searchMode = "contains";

      e.editorOptions.showEditorAlways = true;
      e.editorOptions.opened = true;
      e.editorOptions.searchEnabled = true;
      e.editorOptions.focusStateEnabled = true;
    },
  },
  computed: {
    // sysConfig: function() {
    //   return SysConfig;
    // },
    // listComponent: function() {
    //   return this.$refs.ListComponent;
    // },
    // searchPanel: function() {
    //   return this.$refs.SearchPanel;
    // },
    // actionComponent: function() {
    //   return this.$refs.ActionComponent;
    // },
    // detailFormComponent: function() {
    //   return this.$refs.DetailFormComponent;
    // },
  },
};
